<script setup>
defineProps({
  message: {
    type: String,
    default: "We couldn't load booking details. Check your connection and try again.",
  },
})

defineEmits(['retry'])
</script>

<template>
  <div class="flex flex-col items-center gap-4 text-center">
    <p>{{ message }}</p>
    <button
      type="button"
      class="inline-flex rounded-full bg-secondary px-8 py-3 font-semibold text-white"
      @click="$emit('retry')"
    >
      Try again
    </button>
  </div>
</template>
